import { withDependencies } from '@wix/thunderbolt-ioc'
import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import type { StaticServiceDefinition } from '@wix/static-service'
import type {
	ProvideComponentService,
	ProvideComponentConfig,
} from '@wix/services-manager-react/core-services/provide-component'
import {
	ProvideComponentServiceDefinition as definition,
	ProvideComponentServiceFactory as impl,
} from '@wix/services-manager-react/core-services/provide-component'

export const provideComponentService: FactoryWithDependencies<
	ServiceProvider<StaticServiceDefinition<ProvideComponentService, ProvideComponentConfig>, typeof impl>
> = withDependencies(
	[],
	(): ServiceProvider<StaticServiceDefinition<ProvideComponentService, ProvideComponentConfig>, typeof impl> => {
		return {
			definition,
			impl,
			config: {},
		}
	}
)
